import React, { useEffect } from "react";
import { Grid, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

import img10 from "../../../../assets/MohamedHathaAbdulla.jpg";
import img11 from "../../../../assets/Teresa.jpg";
import img12 from "../../../../assets/RameshRamachandran.jpg";
import img13 from "../../../../assets/Dr. S. Suresh Kumar.jpeg";
import img14 from "../../../../assets/Dr. Idrees Babu K.K.jpeg";
import Header from "../../../../common/Header";
import LeftSideNavigation from "../../../../common/LeftSideNavigation";
import FooterInnerPagee from "../../../../common/FooterInnerPagee";
import image1 from "../../../../assets/people/peoplebannerimg.png";

const BoardMembers = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const teamCategories = [
    {
      title: "Advisory Board Members",
      members: [
        {
          src: img13,
          name: "Dr. S. Suresh Kumar",
          position:
            "Professor of Biological Oceanography and Dean, Faculty of Ocean Science and Technology, KUFOS",
          email: "-",
          qualifications: [
            "M.Sc. and Ph.D. in Marine Biology from Cochin University of Science and Technology (CUSAT)",
          ],
          description: "",
          fullProfile1:
            "Dr. S. Suresh Kumar is a distinguished Professor of Biological Oceanography and currently the Dean of the Faculty of Ocean Science and Technology at the Kerala University of Fisheries and Ocean Studies (KUFOS), Kochi, India. With over 25 years of experience in postgraduate teaching and research, he has made notable contributions to the understanding of ocean productivity, coastal processes, and climate change impacts on marine ecosystems. He holds Master’s and Doctoral degrees in Marine Biology from the Cochin University of Science and Technology (CUSAT) and has served as Principal Investigator in multiple national research projects funded by MoES, ICAR, KSCSTE, and others.",

          fullProfile2:
            "His research focuses on nutrient cycling, primary production, phytoplankton dynamics, and benthic-pelagic coupling, particularly along India’s west coast and island ecosystems. A certified SCUBA diver, Dr. Kumar has carried out extensive field studies in coral reef environments across the Lakshadweep Archipelago. His direct underwater observations have enriched the understanding of reef health, biodiversity, and human-induced stressors. He has contributed to coral reef monitoring and ecological assessments vital for conservation planning in Lakshadweep.",

          fullProfile3:
            "Dr. Kumar is deeply committed to capacity building and scientific mentorship. He actively guides students from Lakshadweep, helping them pursue higher studies and research in marine biology and oceanography. Many of his students have progressed to successful careers in academia, research, and administration. He has published widely in national and international journals and frequently presents at marine science conferences. As a member of academic bodies in multiple universities and an external Ph.D. adjudicator, he plays a vital role in shaping marine science education and policy in India.",
        },
        {
          src: img14,
          name: "Dr. Idrees Babu K.K",
          position: "Senior Marine Scientist",
          email: "-",
          qualifications: [""],
          description: "",

          fullProfile1:
            "Dr. Idrees Babu K.K. is a senior marine scientist with the Department of Science and Technology, Union Territory of Lakshadweep, with over 20 years of experience in coral reef and marine biodiversity research. He is the first islander from Lakshadweep to earn both undergraduate and postgraduate degrees in Aquaculture and holds a Ph.D. in Coral Reef Studies from Mahatma Gandhi University. He also qualified the ICAR-NET in Fish and Fishery Science. His research covers coral reef conservation, marine biodiversity assessment, shoreline management, and climate change impacts.",

          fullProfile2:
            "He has developed coral and seagrass restoration tools through community-based approaches and is a key contributor to Integrated Island Management Plans and marine spatial planning in Lakshadweep. An experienced SCUBA diver, Dr. Babu has discovered five new fish species and 24 new fish records for Indian waters—earning the rare honor of having *Casio idreesi* named after him. He has published widely in national and international journals and mentored numerous master’s and Ph.D. students; he has also led the submission of more than 400 fish sequences to NCBI.",

          fullProfile3:
            "His ongoing projects focus on reef health, climate resilience, and habitat restoration. Dr. Babu’s contributions to marine conservation and ecosystem restoration have earned him international recognition and deeply impacted community-based scientific programs in Lakshadweep. Through his leadership in environmental education and local outreach, he has empowered islanders with knowledge and pride in their natural heritage. As the founder of multiple research and educational initiatives, he continues to inspire and guide the youth of Lakshadweep, leaving a lasting legacy of conservation and sustainable development in the archipelago.",
        },
        {
          src: img12,
          name: "Prof. Dr. Ramesh Ramachandran",
          position:
            "Founder Director NATIONAL CENTRE FOR SUSTAINABLE COASTAL MANAGEMENT( NCSCM)",
          email: "rramesh_au@yahoo.com",
          qualifications: [""],
          description: "",
          fullProfile1:
            "As Former Chair of Future Coasts (formerly Land Ocean Interactions in the Coastal Zone; LOICZ) from 2011 to 2015, he implemented the LOICZ Nutrient Budget for major estuaries on the east and west coast of India among several other studies globally. For the past decade, Ramesh Ramachandran has been involved in coupled land-ocean interface studies, its management, to aid policy decisions of the Ministry of Environment, Forest & Climate Change.",

          fullProfile2:
            "As the Founder Director of the National Centre for Sustainable Coastal Management of the Ministry of Environment, Forest & Climate Change, several trans-disciplinary research studies spanning coastal vulnerability, socio-economic development, coastal/ marine conservation, spatial planning, land-based pollution, island management, integrated coastal zone management and climate change are being undertaken under his leadership.",

          fullProfile3:
            "Currently he is chairing the steering committee of Global Partnership on Nutrient Management (GPNM)-UNEP. Dr. Ramesh coordinated with the Ministry of Environment, Forest and Climate Change, New Delhi and Ministry of External Affairs, Nairobi in the negotiations leading to the UNEA-4 Resolution on “Sustainable Nitrogen Management”, led for the first time by India, in the United Nations. Currently, he serves as the National Focal Point and Member Secretary of the National Working Group on Sustainable Nitrogen Management.",
        },
        {
          src: img11,
          name: "Teresa Alcoverro Pedrola,  PhD",
          position: "Scientific Researcher.",
          email: "-",
          qualifications: [""],
          description: "",
          fullProfile1:
            "My research interests are centred on the role that biological interactions, both direct and indirect, play in the functioning of benthic marine systems dominated by primary producers (macroalgae, seagrass meadows and coral). These systems are strongly influenced by predation and herbivory, and are prone to dramatic shifts in ecosystem state. These studies have led me to being increasingly interested in how these processes play out across the landscape, and how the movement and behaviour of predators and herbivores can influence the distribution and impact of these functions.",

          fullProfile2:
            "I am particularly interested in understanding the role of megaherbivores (dugongs and turtles) in these systems – at ecological, historical and evolutionary time scales. All these studies fit into a larger understanding of the resilience (resistance and recovery capacity) of nearshore benthic systems in the face of rapid global change (increasing temperatures, overfishing, invasive species and eutrophication). I am fascinated by the feedbacks that allow these systems to exist in stable states, and the unravelling of these feedbacks when these systems are pushed beyond critical thresholds.",

          fullProfile3:
            "My studies make use of long time series data (collected by me over the last two decades), combining observational trends with manipulative field and laboratory experiments, gradient-based studies and modelling approaches. Finally, thanks in part to the projects I am developing in India, I am becoming increasingly interested in understanding the functioning of coupled human-ecological systems, particularly the central role of resource-use institutions in regulating fishery overharvests. My work focuses on three geographical regions, the Mediterranean, the Lakshadweep Archipelago and the Andaman and Nicobar Islands in the Indian Ocean.",
        },
        {
          src: img10,
          name: "Prof. (Dr). A.A. MOHAMED HATHA ABDULLA",
          position: "Professor",
          email: "-",
          qualifications: [
            "Department of Marine Biology, Microbiology and Biochemistry Cochin University of Science and TechnologyKochi - 682022, Kerala, India",
          ],
          description: "",
          fullProfile1:
            "Dr. Mohamed Hatha took his Master’s Degree in Marine Biology from CUSAT and Ph.D. in Environmental Microbiology from Bharathiar University,. Started off his career in Industry as Head of Quality Assurance Division of a leading seafood processor and exporter where he developed HACCP based production in seafood industry for the first time in India. He was instrumental in getting the coveted USFDA A listing for the company.",

          fullProfile2:
            "In 1996 Dr. Hatha shifted to teaching and research and taught in various universities in India and abroad since then. Being a passionate academic, he is awarded with Fulbright Scholarship in 2012 and spent a short stint as Fulbright Visiting Scholar at Michigan State university, USA and gave series of lectures at different universities and research institutions in USA, including National Oceanic and Atmospheric Administration(NOAA,), Gulf coast laboratory in Miami, Florida.",

          fullProfile3:
            "Dr. Hatha has brought in substantial research grants to the university through extramural funding.\n\nhttps://publons.com/researcher/1249669/mohamed-hatha-abdulla/\nhttps://scholar.google.co.in/citations?user=oEKULDEAAAAJ&hl=en",
        },
      ],
    },
  ];

  return (
    <>
      <Grid container>
        <Header />
        {/* Full-width Hero Image */}
        <Grid
          item
          xs={12}
          sx={{
            height: { xs: "60vh", md: "70vh" },
            backgroundImage: `url(${image1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />

        {/* Main Content Area - Below Hero Image */}
        <Grid container sx={{ bgcolor: "#f5f5f5", color: "#fff" }}>
          {/* For desktop - Left Side Navigation appears first (left side) */}
          <Grid
            item
            md={3}
            sx={{
              p: 3,
              display: { xs: "none", md: "block" },
              mt: 11,
            }}
          >
            <LeftSideNavigation />
          </Grid>

          {/* Right Side Content - Takes full width on mobile, 75% on desktop */}
          <Grid
            item
            xs={12}
            md={8}
            sx={{
              p: 3,
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)", // Added box shadow
              borderRadius: "8px", // Added border radius
              margin: { md: "24px 24px 24px 0" }, // Added margin for desktop
              backgroundColor: "#fff", // Added white background
            }}
          >
            {teamCategories.map((category, catIndex) => (
              <Grid
                key={catIndex}
                item
                xs={12}
                sx={{
                  px: 3,
                  py: 4,
                  justifyContent: "center",
                  borderBottom:
                    catIndex !== teamCategories.length - 1
                      ? "1px solid #eee"
                      : "none", // Lighter border
                }}
              >
                <Typography
                  variant="h5"
                  align="center"
                  gutterBottom
                  sx={{
                    fontWeight: "bold",
                    mb: 3,
                    fontFamily: "Montserrat, sans-serif",
                    color: "#000",
                    textTransform: "uppercase",
                    letterSpacing: "1px",
                  }}
                >
                  {category.title}
                </Typography>
                <Grid container spacing={3} justifyContent="center">
                  {category.members.map((member, memIndex) => {
                    const globalIndex = `${catIndex}-${memIndex}`;
                    return (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        key={member.name}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Box
                          sx={{
                            width: 250,
                            height: "100%",
                            borderRadius: 3,
                            cursor: "pointer",
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                            // boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', // Shadow for cards
                            transition:
                              "transform 0.3s ease, box-shadow 0.3s ease",
                            "&:hover": {
                              transform: "translateY(-5px)",
                              boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.15)",
                            },
                          }}
                          onClick={() =>
                            navigate(`/profile/${globalIndex}`, {
                              state: { member },
                            })
                          }
                        >
                          <Box
                            sx={{
                              height: 360,
                              overflow: "hidden",
                              flexShrink: 0,
                              "& img": {
                                transition: "transform 0.5s ease",
                              },
                              "&:hover img": {
                                transform: "scale(1.05)",
                              },
                            }}
                          >
                            <img
                              src={member.src}
                              alt={member.name}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          </Box>
                          <Box
                            sx={{
                              p: 2,
                              backgroundColor: "#fff",
                            }}
                          >
                            <Typography
                              variant="subtitle1"
                              fontWeight="bold"
                              color="#000"
                              sx={{
                                fontFamily: "Montserrat, sans-serif",
                                mb: 1,
                              }}
                            >
                              {member.name}
                            </Typography>
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{
                                fontFamily: "Montserrat, sans-serif",
                                letterSpacing: 0,
                                fontSize: "0.875rem",
                              }}
                            >
                              {member.position}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
            ))}
          </Grid>

          {/* For mobile - Left Side Navigation appears after main content */}
          <Grid
            item
            xs={12}
            sx={{
              p: 3,
              display: { xs: "block", md: "none" },
            }}
          >
            <LeftSideNavigation />
          </Grid>
        </Grid>
      </Grid>
      <FooterInnerPagee />
    </>
  );
};

export default BoardMembers;
